export const isEmbeddedDashboardPath = (path: string): boolean => path.startsWith("/embedded/");

export const isAdminDashboardPath = (path: string): boolean => path === "/admin" || path.startsWith("/admin/");

export const shouldHideHelpScoutBeacon = (path: string): boolean => (
  isEmbeddedDashboardPath(path) || isAdminDashboardPath(path) || /^\/(client|expert)\/messages(?:\/|$)/.test(path)
);
